const WorldpayConfig = require('@/lib/PaymentMethods/Worldpay/WorldpayConfig');
const WorldpayDriver = require('@/lib/PaymentMethods/Worldpay/WorldpayDriver');

app.factory(
    'worldpayConfigService',
    /**
     * @param hydrator
     * @param {CurrentDevice} currentDevice
     * @param {PaymentMethodService} paymentMethodService
     * @param {UserService} userService
     */
    function (
        hydrator,
        currentDevice,
        paymentMethodService,
        userService
    ) {
        let config = new WorldpayConfig();

        let paymentMethod = paymentMethodService.getByRef('card-worldpay-chip-and-pin');
        if (!paymentMethod) {
            throw new Error('Company does not have Worldpay payment method enabled.');
        }

        // Set config from the company's payment method config.
        if (paymentMethod.config) {
            let companyTerminalConfig = JSON.parse(paymentMethod.config);
            hydrator.hydrate(companyTerminalConfig, config);
        }

        // Set config from the device's payment method config.
        let device = currentDevice.device;
        if (device.paymentTerminalConfig) {
            if (device.paymentTerminalConfig.hasOwnProperty('card-worldpay-chip-and-pin')) {
                hydrator.hydrate(device.paymentTerminalConfig['card-worldpay-chip-and-pin'], config);
            }
        }

        // Set config from the user's payment method config.
        if (userService.paymentTerminalConfig) {
            if (userService.paymentTerminalConfig.hasOwnProperty('card-worldpay-chip-and-pin')) {
                hydrator.hydrate(userService.paymentTerminalConfig['card-worldpay-chip-and-pin'], config);
            }
        }

        return config;
    }
);

app.service('worldpayDriverService', WorldpayDriver);
